import ExamList from "@/controllers/exam/exam-list.js";
import CONFIG from "@/assets/js/config.custom.js";
import store from '@/store';
import axios from "axios";

export default {
  extends: ExamList,

  data() {
    return {
      selectedExamType: '',
      examTypeArr: CONFIG.EXAM_TYPE,
    }
  },

  methods: {
    excelImport() {
      this.$router.push({ name: 'examImport' });
    },

    examTypeText(typeId) {
      const type = this.examTypeArr.find(t => t.id == typeId || t.id == String(typeId));
      return type ? type.text : '';
    },

    getClass($yearId) {
      if (this.auth('teacher').check()) {
        axios.get("/teacher/getGradeAndClass/" + store.state.user.id, {
          params: {
            campus_id: store.state.user.campus_id,
          }
        })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace("login");
          }
          this.isLoading = false;
        });
        return;
      }

      // For admin, use the default class list endpoint
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: store.state.user.campus_id,
          exclude_early_year: 1,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getAcademicYear() {
      axios.get('period/term/options')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Academic Term'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.terms || []);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);

      if (fieldName === 'term_id') {
        const selectedTerm = this.academicYearArr?.find(term => String(term.id) === String(val));
        this.academic_year = selectedTerm?.academic_year_id || 0;
        this.selectedClass = 0;
        this.class_id = 0;
        this.classArr = [];
        this.getClass(this.academic_year);
      }
    },

    selectEvent({ id }, fieldName) {
      const value = id == 'Select' ? '' : id;
      this.$set(this, fieldName, value);

      if (fieldName === 'term_id') {
        const selectedTerm = this.academicYearArr?.find(term => String(term.id) === String(value));
        this.academic_year = selectedTerm?.academic_year_id || 0;
      }
    },

    searchExam(page = 1) {
      this.searchBtnStatus = true;
      this.isLoading = true;

      const params = {
        academic_year: this.academic_year,
        term_id: this.term_id,
        class_id: this.class_id,
        exam_name: this.exam_name,
        exam_type: this.selectedExamType,
        campus_id: store.state.user.campus_id,
        start_date: this.start_date,
        end_date: this.end_date,
      };

      this.searchedData = { ...params, search_status: this.searchBtnStatus };
      this.isSearched = true;

      axios.get("/exam/search?page=" + page, { params })
        .then((response) => {
          this.search_status = true;
          this.examList = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Exam Search API Error", error);
        });
    },

    reset() {
      this.selectedYear = 0;
      this.term_id = 0;
      this.academic_year = 0;
      this.selectedClass = 0;
      this.class_id = 0;
      this.exam_name = '';
      this.selectedExamType = '';
      this.classArr = [];
      this.start_date = '';
      this.end_date = '';
      this.isLoading = true;
      this.getExamList();
      this.isSearched = false;
    },
  }
};
